import React, { useState } from 'react';

import { ProviderContext } from '../Context';

export const DropdownProvider = props => {
  const [dropdownState, setDropdownState] = useState({});

  const setDropdown = (model, isActive) => {
    setDropdownState(isActive ? { model } : {});
  };

  return (
    <ProviderContext.Provider
      {...props}
      value={{
        dropdownState,
        setDropdownState,
        setDropdown,
      }}
    />
  );
};
